import './index.css'

const RepositoryItem = props => {
  const {repositoryDetails} = props
  const {
    name,
    issuesCount,
    forksCount,
    starsCount,
    avatarUrl,
  } = repositoryDetails

  return (
    <li className="repository-item">
      <img src={avatarUrl} alt={name} className="repository-avatar" />
      <h1 className="repository-name">{name}</h1>
      <div className="stats-container">
        <div className="stat-item">
          <img
            src="https://assets.ccbp.in/frontend/react-js/stars-count-img.png"
            alt="stars"
            className="stat-icon"
          />
          <p className="stat-text">{starsCount} stars</p>
        </div>
        <div className="stat-item">
          <img
            src="https://assets.ccbp.in/frontend/react-js/forks-count-img.png"
            alt="forks"
            className="stat-icon"
          />
          <p className="stat-text">{forksCount} forks</p>
        </div>
        <div className="stat-item">
          <img
            src="https://assets.ccbp.in/frontend/react-js/issues-count-img.png"
            alt="open issues"
            className="stat-icon"
          />
          <p className="stat-text">{issuesCount} open issues</p>
        </div>
      </div>
    </li>
  )
}

export default RepositoryItem
